import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['dialog']

  disconnect() {
    this.dialog?.remove()
  }

  open({params: {src, id}}) {
    if (!src || !id) {
      console.error('Turbo Frame Modal: Missing src or id parameter.')
      return
    }

    this.dialog?.remove()

    const dialog = document.createElement('dialog')
    dialog.id = `dialog_${id}`
    dialog.classList = 'fixed inset-0 max-h-full max-w-full size-full overflow-y-auto backdrop:bg-transparent'
    dialog.classList.add(...this.dialogClasses)
    dialog.setAttribute('data-turbo-temporary', '')
    dialog.addEventListener('close', () => dialog.remove())
    dialog.innerHTML = `<turbo-frame src="${src}" id="${id}" class="block size-full"></turbo-frame>`

    document.body.appendChild(dialog)
    dialog.showModal()
    this.dialog = dialog
  }
}
